<template>
  <div class="animated fadeIn">
    <b-card>
      <h1>Live Position Engineer & NOC</h1>
        <div class="row">
          <label for="Branch" class="col-sm-2 col-form-label font-weight-bold">Branch</label>
          <div class="col-sm-6">
            <select name="tahun" id="branch" v-model="branch" class="custom-select custom-select-sm">
              <option v-for="bran in branchs" :value="bran.id" :key="bran.id">{{bran.name}}</option>
            </select>
          </div>
          <div class="col-sm-4 text-right">
            <button class="btn btn-info" @click="warningModal = true">Generate</button>
          </div>
        </div>
        <button class="btn btn-primary" @click="submit">
          Submit
        </button>
        <div class="row mobile" v-if="show" style="margin-top: 10px">
          <div class=" col-md-2 col-sm-3 border">
            <span class="title" >PIC  &nbsp;
            <i v-bind:class="sortTeknisi == 1 ? 'fa fa-faw fa-sort' : sortTeknisi == 2 ? 'fa fa-caret-up upCaret': 'fa fa-caret-down downCaret'"
               @click="sort(data, 'string')"
            ></i>
            </span>

          </div>
          <div class=" col-md-10 col-sm-9 border">
            <span class="title">Assign Ticket &nbsp; <i v-bind:class="sortTicket == 1 ? 'fa fa-faw fa-sort' : sortTicket == 2 ? 'fa fa-caret-up upCaret': 'fa fa-caret-down downCaret'"
                                                        @click="sort(data, 'number')"
            ></i></span>

          </div>
        </div>

        <div class="table engineer">
          <div class="row" v-for="engineer in data" v-bind:key="engineer.user_id">
            <div class="col-md-2 col-sm-3 border">
              <span>
                  <a :href="engineer.position"
                     v-bind:title="desc.presence[engineer.presence].desc"
                     v-bind:style="{color: desc.presence[engineer.presence].color}"
                  >{{engineer.name}}</a>
                </span>
                <span class="text-time text-success"
                  v-bind:title="engineer.last_update | changeXtoDate"
                >
                ( {{engineer.last_update | diffTimeNow }} )
                </span>
            </div>
            <div class=" col-md-10 col-sm-9 border">
              <table class="address" width="100%">
                <tr v-for="(ticket, i) in engineer.ticket" v-bind:key="ticket.ticket_id" s>
                  <LiveReportTicketComponent :ticket="ticket" :desc="desc" :i="i" />
                </tr>
              </table>
            </div>
          </div>
        </div>
      <b-row v-if="show">
        <div class="col-md-4">
          <b>Presence</b>
          <div v-for="(presence, i) in desc.presence" v-bind:key="`presence-${i}`">
            <span class="dot" v-bind:style="{background: presence.color}"></span> &nbsp; {{presence.desc}}
          </div>
        </div>
        <div class="col-md-4">
          <b>Status</b>
          <div>
            <i class="fa fa-caret-square-o-right"></i> &nbsp; Work
          </div>
          <div>
            <i class="fa fa-check-square-o"></i> &nbsp; Solved / Closed
          </div>
          <div>
            <i class="fa fa-calendar-check-o"></i> &nbsp; Pending
          </div>
          <div>
            <i class="fa fa-square-o"></i> &nbsp; Open
          </div>
        </div>
        <div class="col-md-4">
          <b>Type Ticket</b>
          <div v-for="(status, key) in desc.ticket_type" :key="key">
            <span class="dot" v-bind:style="{background: status.color}"></span> &nbsp; {{status.name}}
          </div>
        </div>
      </b-row>
      <b-row>
        <div class="col-md-12" style="text-align: center">
          <img :src="$store.getters.base_href + '/iconTicket/req.png'">:&nbsp;Request&nbsp;&nbsp;&nbsp;
          <img :src="$store.getters.base_href + '/iconTicket/request16.png'">:&nbsp;Incident/ NOC &nbsp;&nbsp;
          <img :src="$store.getters.base_href + '/iconTicket/bongkar16.png'"> :&nbsp;Dismantle&nbsp;&nbsp;
          <img :src="$store.getters.base_href + '/iconTicket/pasangbaru16.png'"> :&nbsp;Instalasi Baru&nbsp;&nbsp;
          <img :src="$store.getters.base_href + '/iconTicket/survay16.png'"> :&nbsp;Survey Lokasi&nbsp;&nbsp;
          <img :src="$store.getters.base_href + '/iconTicket/pantaulink16.png'"> :&nbsp;Pantau Link&nbsp;&nbsp;
          <img :src="$store.getters.base_href + '/iconTicket/pindahperangkat16.png'"> :&nbsp;Pindah Perangkat&nbsp;&nbsp;
          <img :src="$store.getters.base_href + '/iconTicket/fiberoptic162.png'"> :&nbsp;Fiber Optic&nbsp;&nbsp;
          <img :src="$store.getters.base_href + '/iconTicket/other16.png'"> :&nbsp;Others&nbsp;&nbsp;
        </div>
      </b-row>
    </b-card>
    <b-modal title="Attention" class="modal-warning" v-model="warningModal" @ok="live(); warningModal == false" ok-variant="warning">
       This process takes a little longer to regenerate, will it continue ?
    </b-modal>
  </div>
</template>

<script>
  import {getService} from "../../services";
  import LiveReportTicketComponent from "./LiveReportTicketComponent"

  export default {
    name: 'livereport',
    components: {
      LiveReportTicketComponent,
    },
    data() {
      return {
        data: [],
        branch: '' ,
        show: false,
        branchs: [],
        desc: [],
        warningModal: false,
        sortTeknisi: 2,
        sortTicket: 1,
        checkBranch: ''
      }
    },
    created: function () {
      this.getBranch()
      this.$store.commit('noLoad', true)
      var that = this
      this.checkBranch = setInterval(() => {
        that.branch =  that.$store.getters.branch
        if (that.branch) {
          that.getLive(that.branch, false)
          clearInterval(that.checkBranch)
        }
      }, 1000);

    },
    methods: {
      submit: function() {
        this.$store.commit('noLoad', true)
        this.getLive(this.branch, false)
      },
      live: function() {
        this.getLive(this.branch, true)
      },
      getLive: function (branch, live) {
        getService.list_live_enginer(branch, live)
          .then(
            data => {
              this.data = []
              this.show = true
              this.$store.commit('noLoad', false)
              this.data = data.data
              this.desc = data.desc

              for (var engineer of data.data) {
                engineer.name = engineer.name.trim().split(/\s+/)
                  .map((x, i) => i < 2 ? x : x[0])
                  .reduce((a, b, i) => [a, b].join(i < 3 ? ' ' : '').trim())

                // engineer.ticket.sort((a, b) => {
                //   if (!(a.status == 'Solved' || a.status == 'Closed') && (b.status == 'Solved' || a.status == 'Closed')) return 1
                //   if ((a.status == 'Solved' || a.status == 'Closed') && !(b.status == 'Solved' || a.status == 'Closed')) return -1
                //   if (a.status != 'Pending' && b.status == 'Pending') return 1
                //   if (a.status == 'Pending' && b.status != 'Pending') return -1
                //   if (!a.current_ticket && b.current_ticket) return 1
                //   if (a.current_ticket && !b.current_ticket) return -1
                //   if (a.status != 'Open' && b.status == 'Open') return 1
                //   if (a.status == 'Open' && b.status != 'Open') return -1
                //   if (a.type != 'Dedicated' && b.type == 'Dedicated') return 1
                //   if (a.type == 'Dedicated' && b.type != 'Dedicated') return -1
                //   if (a.type != 'Broadband' && b.type == 'Broadband') return 1
                //   if (a.type == 'Broadband' && b.type != 'Broadband') return -1
                //   return 0
                // })

                engineer.ticket.sort((a, b) => {
                  if (a.current_ticket === 1 && a.status === 'Open')return -1
                  if (b.current_ticket === 1 && b.status === 'Open') return 1
                  if(a.status === 'Open' && b.status === 'Open' && a.visit_time_sort && a.visit_time_sort < b.visit_time_sort) return -1
                  if(a.status === 'Open' && b.status === 'Open' && a.visit_time_sort && a.visit_time_sort < b.visit_time_sort) return 1
                  if(a.status === 'Open' && b.status === 'Open' && !a.visit_time_sort && b.visit_time_sort) return 1
                  if(a.status === 'Open' && b.status === 'Open' && a.visit_time_sort && !b.visit_time_sort) return -1
                  if(a.status === 'Pending') return 1
                  if(a.status !== 'Open' && b.status === 'Pending') return -1
                  if (a.status !== 'Open' && b.status === 'Open') return 1
                  if (a.status === 'Open' && b.status !== 'Open') return -1
                  if(a.status === 'Open' || b.status === 'Open') return -1
                  return -1
                })

              }
            },
            error => {
              this.$store.commit('noLoad', false)
              alert('Error')
            }
          )
      },
      compareStrings(a, b, condition) {
        // Assuming you want case-insensitive comparison
        if (typeof a == 'string') {
          a = a.toLowerCase();
          b = b.toLowerCase();
        }
        if (condition) {
          return (a < b) ? -1 : (a > b) ? 1 : 0;
        } else {
          return (a > b) ? -1 : (a < b) ? 1 : 0;
        }

      },
      sort(name, type) {
        var that = this
        var condition, key
        if (type == 'string') {
          this.sortTicket = 1
          if (this.sortTeknisi == 2) {
            this.sortTeknisi = 3
            condition = false
          } else {
            this.sortTeknisi = 2
            condition = true
          }
        } else {
          this.sortTeknisi = 1
          if (this.sortTicket == 2) {
            this.sortTicket = 3
            condition = false
          } else {
            this.sortTicket = 2
            condition = true
          }
        }

        key = type == 'string' ? 'name' : 'ticket_count'

        name.sort(function (a, b) {
          return that.compareStrings(a[key], b[key], condition);
        })
      },
      async getBranch() {
        try {
          await getService.list_branch()
            .then(data => {
              this.branchs = data
            })
        } catch (error) {
          // bila data tidak terpanggil
        }
      }
    },
  }
</script>

<style>
  .dot {
    height: 15px;
    width: 15px;
    background-color: #bbb;
    border-radius: 25%;
    display: inline-block;
  }

  .upCaret {
    position: absolute;
    cursor: pointer;
    top:2px;
  }

  .downCaret{
    position: absolute;
    cursor: pointer;
    bottom: 2px;
  }

  .text-time{
    font-size: 10px;
    display: block;
  }

  table.address>tr>td{
    border: 0px !important;
  }

  td.number{
    min-width: 50px;
    padding-right: 2px;
    padding-left: 5px;
  }

  td.ticket {
    padding-left: 5px;
  }

  .engineer > .row:nth-child(2n){
    background-color: rgba(32, 168, 216, 0.1);
  }

  .title {
    font-weight: bold;
    font-size: 15px;
  }
  @media only screen and (max-width: 767px) {
    .mobile {
      display: none;
    }
  }

</style>
